export default __webpack_public_path__ + "static/media/4.2c8afce0.jpg";